import { useState } from "react";
import { Typography, Button, Drawer, useTheme, useMediaQuery } from "@mui/material";
import { IconFileTypeDoc, IconTrash } from "@tabler/icons-react";
import paths from "../../utils/paths";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function CartDrawer({
  cartDrawerOpen,
  setCartDrawerOpen,
  isLightMode,
}) {
  const navigate = useNavigate();
  const [getCartDetails, setCartDetails] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getUserCartDetails = async (id) => {
    try {
      var response = await axios.get("/advocate/advocate/getCartDetails");

      if (response.data.status === true) {
        setCartDetails(response.data.Message);
      } else {
        setCartDetails([]);
      }
    } catch (error) {}
  };

  const checkout = async (item) => {
    try {
      var obj = {
        type: localStorage.getItem("type"),
        data: item,
      };
      const response = await axios.post("advocate/advocate/checkoutCart", obj);

      if (response.data.status === true) {
        toast.success(response.data.Message);
        getUserCartDetails();
        window.location.href = "/legaltemplates";
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {}
  };

  const remove = async (item) => {
    try {
      var obj = {
        type: localStorage.getItem("type"),
        _id: item._id,
      };
      var response = await axios.post(
        "/advocate/advocate/removCartDetails",
        obj
      );
      if (response.data.status === true) {
        toast.success(response.data.Message);
        getUserCartDetails();
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {}
  };

  return (
    <>
      {/* CART DRAWER */}
      <Drawer
        anchor="right"
        open={cartDrawerOpen}
        onClose={() => setCartDrawerOpen(false)}
        sx={{ width: "300px" }}
      >
        <div
          style={{
            width: isMobile ? "270px" : "400px",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            backgroundColor: isLightMode ? "#fff" : "#000",
            color: isLightMode ? "#000" : "#fff",
            height: "100vh",
          }}
        >
          <Typography variant="h6">Your Cart</Typography>

          <span>
            Request Extra LBT & XDC tokens via Profile{" "}
            <span
              className="gotoprofile ri-share-box-fill"
              style={{ cursor: "pointer" }}
              role="button"
              tabIndex={0}
              aria-label="Go to profile"
              onClick={() => navigate(paths.Profile)}
            ></span>
          </span>
          {/* Cart items or content here */}
          <div className="scroll_cart">
            <div className="cart-item-container">
              {getCartDetails.map((item, i) => {
                return (
                  <div className="cart-item" key={item?._id}>
                    <div className="main_cart_item">
                      <div className="cart-item-image">
                        <IconFileTypeDoc stroke={1} size={26} />
                      </div>
                      <div className="cart-item-details">
                        <p>{item.name}</p>
                        <span>{item.amount}LBT</span>
                      </div>
                    </div>
                    <Button onClick={() => remove(item)} className="cart_bin">
                      <IconTrash size={20} />
                    </Button>
                  </div>
                );
              })}
            </div>
            <div className="Cart_footer">
              <Button
                onClick={() => checkout(getCartDetails)}
                className="login-btn padding_button"
              >
                Checkout
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}
